import { api } from "lwc";
import Button from "tds/button";
import { Sprite } from "tds/icon";

export default class extends Button {
  @api iconSymbol: string = undefined!;
  @api iconSprite: Sprite = "utility";
  @api iconSize: string = "override";
}
